import axios from 'axios';
import { API_BASE_URL } from '../utils/config';

export const apiClient = axios.create({
  baseURL: API_BASE_URL,
});

export function buildAuthHeaders(token: string | null, guestId?: string | null): Record<string, string> {
  const headers: Record<string, string> = {};
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  } else if (guestId) {
    headers['X-Guest-Id'] = guestId;
  }
  return headers;
}
